import { createContext, useContext } from 'react';

const QueryContext = createContext<any>({});

export const QueryProvider = QueryContext.Provider;
export const QueryConsumer = QueryContext.Consumer;

export const useQuery = (): any => useContext(QueryContext);
